import { Component } from '@angular/core';
import { PageBaseComponent } from '@pit/core';
import { IDtoDepot, IDtoUser } from '@pit/frontend-model';
import { PinItTrackFrontendServicesAccessor } from '@pit/frontend-shared';

@Component({
    selector: 'pin-it-track-frontend-web-main-page',
    templateUrl: './pin.it.track.frontend.web.main.page.component.html',
    styleUrls: ['./pin.it.track.frontend.web.main.page.component.scss']
})
export class PinItTrackFrontendWebMainPageComponent extends PageBaseComponent {

    constructor(private servicesAccessor: PinItTrackFrontendServicesAccessor) {
        super(servicesAccessor.coreServicesAccessor.applicationService);
    }

    public currentUser: IDtoUser = this.servicesAccessor.currentUser;

    public selectedDepot: IDtoDepot = null;

    protected override async doOnAfterViewInitAsync(): Promise<void> {
        await super.doOnAfterViewInitAsync();
    }

}
